import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { Addresses_ReportService } from './Addresses.report.index';
import { Carriers_ReportService } from './Carriers.report.index';
import { PurchaseOrders_ReportService } from './PurchaseOrders.report.index';
import { SalesOrders_ReportService } from './SalesOrders.report.index';
import { Notifications_ReportService } from './Notifications.report.index';
import { Materials_ReportService } from './Materials.report.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { Inventory_ReportService } from './Inventory.report.index';
import { FootprintApiManager_ReportService } from './FootprintApiManager.report.index';
import { Reports_ReportService } from './Reports.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.Addresses = this.injector.get(Addresses_ReportService);
    this.Carriers = this.injector.get(Carriers_ReportService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_ReportService);
    this.SalesOrders = this.injector.get(SalesOrders_ReportService);
    this.Notifications = this.injector.get(Notifications_ReportService);
    this.Materials = this.injector.get(Materials_ReportService);
    this.Invoices = this.injector.get(Invoices_ReportService);
    this.Inventory = this.injector.get(Inventory_ReportService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_ReportService);
    this.Reports = this.injector.get(Reports_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public Addresses: Addresses_ReportService;
    public Carriers: Carriers_ReportService;
    public PurchaseOrders: PurchaseOrders_ReportService;
    public SalesOrders: SalesOrders_ReportService;
    public Notifications: Notifications_ReportService;
    public Materials: Materials_ReportService;
    public Invoices: Invoices_ReportService;
    public Inventory: Inventory_ReportService;
    public FootprintApiManager: FootprintApiManager_ReportService;
    public Reports: Reports_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

